import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import addToTarget from 'rangeConfig/shared/behaviors/addToTarget';
import deleteSelectedEntity from 'rangeConfig/shared/behaviors/deleteSelectedEntity';
import platform from 'rangeConfig/shared/utils/platform';
import DimensionsLabel from 'rangeConfig/shared/widgets/DimensionsLabel';

const interiors = {
  id: 'section-selected-menu-interiors',
  title: 'storageone.productListInteriorsTitle',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [addToTarget],
    productDropped: [addProduct]
  },
  productTypes: [
    ProductType.BROR_SHELF_WALL_METAL_BLACK,
    ProductType.BROR_RAIL,
    ProductType.BROR_PEGBOARD_SET
  ],
  productFilters: []
};

const widgets = {
  desktop: [
    {
      id: 'display-size',
      title: 'storageone.sizeFilterLabel',
      component: DimensionsLabel
    },
    interiors
  ],
  mobile: [interiors]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseSection',
  behaviors: {
    productDeleted: [deleteSelectedEntity]
  },
  content: widgets[platform]
};

export default selectedMenu;
